import Vue from "vue";
export const SET_CURRENT_SCHEMA = "SET_CURRENT_SCHEMA";
export const SET_CURRENT_WIDGET_DATA = "SET_CURRENT_WIDGET_DATA";
export const SET_CURRENT_WIDGET_DATA_KEY = "SET_CURRENT_WIDGET_DATA_KEY";
export const SET_WIDGET_DISCLAIMERS = "SET_WIDGET_DISCLAIMERS";
export const RESET_WIDGET_DATA = "RESET_WIDGET_DATA";
export const SET_WIDGET_SCHEMA_VALIDATIONS = "SET_WIDGET_SCHEMA_VALIDATIONS";
const mutations = {
  [SET_CURRENT_SCHEMA]: (state, schema) => {
    Vue.set(state, "currentSchema", schema);
  },
  [SET_CURRENT_WIDGET_DATA]: (state, data) => {
    Vue.set(state, "currentWidgetData", data);
  },
  [SET_CURRENT_WIDGET_DATA_KEY]: (state, {
    sectionKey,
    columnKey,
    value
  }) => {
    Vue.set(state.currentWidgetData[sectionKey], columnKey, value);
  },
  [SET_WIDGET_DISCLAIMERS]: (state, {
    disclaimers
  }) => {
    Vue.set(state, "widgetDisclaimers", disclaimers);
  },
  [SET_WIDGET_SCHEMA_VALIDATIONS]: (state, {
    validations
  }) => {
    Vue.set(state, "schemaValidations", validations);
  },
  [RESET_WIDGET_DATA]: state => {
    state.currentWidgetData = {};
    state.currentSchema = {};
    state.widgetDisclaimers = [];
  }
};
export default mutations;